import api from "../config/api"


export const getALLDestinations = async () => {
    const response = await api.get('/destination/');
    return response.data;
}

export const getDestinationById = async (id) => {
    const response = await api.get(`/destination/?id${id}`);
    return response.data;
}

export const saveDestination = async (data) => {
    const response = await api.post(`/destination/`, data, {
        headers: { "Content-Type": "application/json" },
    })
    return response;
}

export const deleteDestination = async (id) => {
    const response = await api.delete(`/destination/?id=${id}`);
    return response.data;
}